import JobResume from './JobResume.container';

export default JobResume;
